import {
  easypostFedexMfaGeneratePinInputSchema,
  easypostFedexMfaGeneratePinOutputSchema,
} from "@redotech/redo-fulfillment-carrier-account-common/easypost-fedex-mfa";

export const easypostFedexMfaGeneratePin = {
  name: "easypostFedexMfaGeneratePin" as const,
  input: easypostFedexMfaGeneratePinInputSchema,
  output: easypostFedexMfaGeneratePinOutputSchema,
};
